import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const AuthenticationCard = styled.img`
  width: 60px;
  margin: 0 auto 24px auto;
`;

export const Email = styled.strong`
  color: black;
  font-weight: 600;
  margin-bottom: 24px;
`;

export const Detail = styled.span`
  font-size: 14px;
  color: ${ColorPalette.HEX.MetallicSilver};
  margin-bottom: 20px;
`;
